module.exports = __webpack_public_path__ + "img/salvavidas-logo.a46fddf4.png";